<template>
  <div class="bbjzh-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="申请状态">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="审核中" :value="1" />
                <el-option label="审核通过" :value="2" />
                <el-option label="审核拒绝" :value="0" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button type="primary" @click="editApply(0)" icon="el-icon-plus">添加报备金</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="报备金名称"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.delname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="报备金额"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.amount}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="报备订单"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      共 <b>{{scope.row.num}}</b> 订单
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="报备要求"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.per}}/单
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="有效期"
                    width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.starttime}} ~ {{scope.row.endtime}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请人"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.username}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请时间"
                    width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1" type="warning">待审核</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2">审核通过</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="danger">审核拒绝</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    align="center"
                    fixed="right"
                    label="操作">
                    <template slot-scope="scope">
                      <el-dropdown v-if="scope.row.mark!==2" size="mini" @click="editApply(scope.row.darid)" split-button icon="el-icon-edit">
                        <i class="el-icon-edit"></i> 编辑
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="delApply(scope.row.darid)" style="color:#F56C6C"><i class="el-icon-delete"></i> 删除申请</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button icon="el-icon-search" @click="view(scope.row)" size="mini" v-if="scope.row.mark===2">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" v-loading="infoLoading" :model="editForm" :rules="editRules"  label-position="right" label-width="90px" size="small">
        <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info"></i> 申请须知：该申请仅限" <b>报备金</b> "使用，实际收款/业绩支票返点/售后赔款请勿在此申请
        </div>
        <el-form-item label="审核信息" v-if="audittime!==null&&audittime!==''">
          <el-card class="box-card">
            <div style="color:#606266;font-size: 13px;">
              <span><span style="color:#99a9bf">审核时间：</span>{{audittime}}</span>
              <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{auditname}}</span>
            </div>
            <div style="color:#606266;font-size: 13px;" v-if="auditrson!==''&&auditrson!==null">
              <span style="color:#99a9bf">拒绝原因：</span>{{auditrson}}
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="经销商" prop="delid">
          <el-select v-model="editForm.delid" filterable clearable style="width:400px">
            <el-option
              v-for="item in dealerInfo"
              :key="item.delid"
              :label="item.allname"
              :value="item.delid">
              <span style="float: left">{{ item.allname }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.province }} {{ item.city }} {{ item.county }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报备金名称" prop="name">
          <el-input v-model="editForm.name" maxlength="200" placeholder="请输入报备金名称" show-word-limit></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="10">
            <el-form-item label="报备要求" prop="per">
              <el-input v-model="editForm.per" oninput ="value=value.replace(/[^0-9.]/g,'')"><template slot="append">元/单</template></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="最低折扣" prop="mindiscount">
              <el-input v-model="editForm.mindiscount" oninput ="value=value.replace(/[^0-9.]/g,'')"><template slot="append">折（同比享受最低折扣）</template></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="报备订单" prop="order">
          <el-card shadow="never" style="font-size: 12px">
            <div style="margin-bottom: 10px">
              <span style="color:#99a9bf;font-size:12px;"><i class="el-icon-warning-outline"></i> 至少添加一个报备订单终端地址</span>
              <el-button icon="el-icon-plus" style="float: right" @click="addOrder">添加终端地址</el-button>
            </div>
            <div v-for="(item, index) in editForm.order" :key="item.key" >
              <el-col :span="21">
                <el-form-item :prop="'order.' + index +'.address'" :rules="orderRules.address">
                  <el-input v-model="item.address" placeholder="请输入终端地址" maxlength="100"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3" style="padding: 0 6px">
                <el-button type="danger" @click="delOrder(index)" icon="el-icon-delete" plain></el-button>
              </el-col>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="对应折扣" prop="discount">
          <el-card shadow="never" style="font-size: 12px">
            <div style="margin-bottom: 10px">
              <span style="color:#99a9bf;font-size:12px;" v-if="editForm.starttime===''||editForm.starttime===null||editForm.starttime===undefined"><i class="el-icon-warning-outline"></i> 至少添加一个对应折扣</span>
              <span style="color:#409EFF;font-size:12px;" v-if="editForm.starttime!==''&&editForm.starttime!==null&&editForm.starttime!==undefined">
                <i class="el-icon-warning-outline"></i> 提示：<b>{{editForm.endtime}}</b> 之后报备金所剩余额将自动放入账户余额
              </span>
              <el-button icon="el-icon-plus" style="float: right" @click="addDiscount">添加折扣</el-button>
            </div>
            <div v-for="(item, index) in editForm.discount" :key="item.key" >
              <el-col :span="15">
                <el-form-item :prop="'discount.' + index +'.time'" :rules="discountRules.time">
                  <el-date-picker
                    v-model="item.time"
                    format="yyyy年MM月dd日"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :prop="'discount.' + index +'.val'" :rules="discountRules.val">
                  <el-input v-model="item.val" oninput ="value=value.replace(/[^0-9.]/g,'')"><template slot="append">折</template></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3" style="padding: 0 6px">
                <el-button type="danger" @click="delDiscount(index)" icon="el-icon-delete" plain></el-button>
              </el-col>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="收款账户" prop="aid">
          <el-select v-model="editForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name">
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-row>
          <el-col :span="10">
            <el-form-item label="收款性质" prop="nature">
              <el-select v-model="editForm.nature">
                <el-option
                  v-for="item in receiptNatureList"
                  :key="item.rntid"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="收款日期" prop="receipttime">
              <el-date-picker
                v-model="editForm.receipttime"
                type="date"
                style="width:180px"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="收款金额" prop="amount">
              <el-input v-model="editForm.amount" oninput ="value=value.replace(/[^0-9.]/g,'')"><template slot="append">元</template></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="卡号" prop="card">
              <el-input v-model="editForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="报备凭证" prop="imgids">
          <span style="color:#99a9bf;font-size: 12px"><i class="el-icon-info"></i> 凭证提示：请将打款凭证与报备金文件一并上传</span>
          <MultiImg :limit="9" :size="'sm'" :old="editimgList" :key="imgLoad" v-model="editForm.imgids" />
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input type="textarea" v-model="editForm.remark"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="报备金详情"
      :visible.sync="viewVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="viewLoading">
        <tr>
          <th>申请人</th>
          <td>{{ viewdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewdata.delname }}</td>
          <th style="width: 100px">报备金名称</th>
          <td colspan="3" style="color:#000;">{{ viewdata.name }}</td>
        </tr>
        <tr>
          <th>报备要求</th>
          <td>
            {{viewdata.per}}/单
          </td>
          <td colspan="4">
            同比享受最低折扣不低于 {{viewdata.mindiscount}} 折
          </td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewAddress">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.address }}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span><i class="el-icon-date"></i> {{viewdata.starttime}} ~ {{viewdata.endtime}}</span>
            <span style="color:#F56C6C;margin-left: 20px"><i class="el-icon-warning-outline"></i> {{viewdata.endtime}} 之后报备金所剩余额将自动放入账户余额</span>
          </td>
        </tr>
        <tr>
          <th>对应折扣</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewDiscount">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.starttime }} 至 {{ d.endtime }}</td>
                <td style="width: 100px;text-align: center">{{ d.discount }}折</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="5">{{ viewAcccount.groupname }}（{{ viewAcccount.name }}，{{ viewAcccount.card }}）</td>
        </tr>
        <tr>
          <th>打款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewdata.amount }}</td>
          <th>打款日期</th>
          <td>{{ viewdata.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ viewdata.nature }}</td>
        </tr>
        <tr>
          <th>报备凭证</th>
          <td colspan="5">
            <el-image v-for="iurl in imgSrcList"
                      style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                      :src="iurl"
                      :preview-src-list="imgSrcList">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewdata.remark }}</td>
        </tr>
        <tr  v-if="viewdata.mark===2">
          <th>审核人</th>
          <td>{{ viewdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getReceiptNature, getDealerAccountReportApplyList, getErpDealerList, addOrEditDealerAccountReport, getDealerAccountReportById, deleteDealerAccountReport } from '@/api/erp'
import { getAccounts, getGroupReport } from '@/api/pub'
import MultiImg from '@/components/upload/MultiImg'
import qs from 'qs'

export default {
  name: 'bbjzh',
  computed: {
    user: getUser
  },
  components: {
    MultiImg
  },
  data() {
    const validateOrder = (rule, value, callback) => {
      if (value !== null && value !== undefined) {
        if (value.length <= 0) {
          callback(new Error('至少添加一个报备订单终端地址'))
        } else {
          callback()
        }
      } else {
        callback(new Error('至少添加一个报备订单终端地址'))
      }
    }
    const validateDiscount = (rule, value, callback) => {
      if (value !== null && value !== undefined) {
        if (value.length <= 0) {
          callback(new Error('至少添加一个对应折扣'))
        } else {
          callback()
        }
      } else {
        callback(new Error('至少添加一个对应折扣'))
      }
    }
    const validateTime = (rule, value, callback) => {
      if (value !== null && value !== undefined) {
        if (value.length !== 2) {
          callback(new Error('请选择打款下单时间'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请选择打款下单时间'))
      }
    }
    return {
      viewVisible: false,
      viewLoading: false,
      searchForm: {
        search: '',
        type: null
      },
      imgSrcList: [],
      viewdata: [],
      viewAddress: [],
      viewDiscount: [],
      viewAcccount: [],
      fullscreenLoading: false,
      editTitle: '添加收款申请',
      dealerInfo: [],
      groupList: [],
      accountsList: [],
      receiptNatureList: [],
      imgLoad: '',
      editimgList: [],
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      audittime: '',
      auditname: '',
      auditrson: '',
      infoLoading: false,
      editForm: {
        darid: null,
        delid: '',
        name: '',
        aid: null,
        receipttime: '',
        card: '',
        nature: '',
        amount: null,
        per: null,
        mindiscount: null,
        remark: '',
        imgids: [],
        order: [],
        discount: [],
        starttime: '',
        endtime: ''
      },
      editRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        name: [{ required: true, message: '请输入报备金名称', trigger: 'blur' }],
        aid: [{ required: true, message: '请选择收款账户', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        card: [{ required: true, message: '请输入卡号', trigger: 'blur' }],
        per: [{ required: true, message: '请输入报备要求', trigger: 'blur' }],
        nature: [{ required: true, message: '请选择打款性质', trigger: 'change' }],
        amount: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        order: [{ required: true, trigger: 'change', validator: validateOrder }],
        mindiscount: [{ required: true, message: '请输入最低折扣', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传报备凭证', trigger: 'change' }],
        discount: [{ required: true, trigger: 'change', validator: validateDiscount }]
      },
      orderRules: {
        address: [{ required: true, message: '请输入终端地址', trigger: 'blur' }]
      },
      discountRules: {
        time: [{ required: true, trigger: 'change', validator: validateTime }],
        val: [{ required: true, message: '请输入对应折扣', trigger: 'blur' }]
      },
      editloading: false
    }
  },
  watch: {
    'editForm.discount': {
      handler(newValue, oldValue) {
        this.setTime()
      },
      deep: true
    }
  },
  created() {
    this.getData()
    getErpDealerList({ userid: this.user.dUserid }).then(response => {
      this.dealerInfo = response.data
    }).catch(() => {
      this.dealerInfo = []
    })
    getGroupReport().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
    getReceiptNature().then(response => {
      this.receiptNatureList = response.data
    }).catch(() => {})
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        mark: this.searchForm.type,
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid
      }
      getDealerAccountReportApplyList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    addOrder() {
      this.editForm.order.push({ address: '' })
    },
    delOrder(index) {
      this.editForm.order.splice(index, 1)
    },
    addDiscount() {
      this.editForm.discount.push({ time: [], val: null })
    },
    delDiscount(index) {
      this.editForm.discount.splice(index, 1)
    },
    setTime() {
      this.editForm.starttime = ''
      this.editForm.endtime = ''
      if (this.editForm.discount.length > 0) {
        for (let d of this.editForm.discount) {
          if (d.time.length === 2) {
            if (this.editForm.starttime !== '' && this.editForm.starttime !== null && this.editForm.starttime !== undefined) {
              const oldsd = new Date(Date.parse(this.editForm.starttime))
              const sd = new Date(Date.parse(d.time[0]))
              if (sd < oldsd) {
                this.editForm.starttime = d.time[0]
              }
              const olded = new Date(Date.parse(this.editForm.endtime))
              const ed = new Date(Date.parse(d.time[1]))
              if (ed > olded) {
                this.editForm.endtime = d.time[1]
              }
            } else {
              this.editForm.starttime = d.time[0]
              this.editForm.endtime = d.time[1]
            }
          }
        }
      }
    },
    editApply(id) {
      if (id === 0) {
        this.editTitle = '添加报备金申请'
        this.editForm.darid = 0
        this.editForm.delid = ''
        this.editForm.name = ''
        this.editForm.aid = null
        this.editForm.receipttime = ''
        this.editForm.card = ''
        this.editForm.nature = ''
        this.editForm.amount = null
        this.editForm.per = null
        this.editForm.mindiscount = null
        this.editForm.remark = ''
        this.editForm.imgids = []
        this.editimgList = []
        this.editForm.order = []
        this.editForm.discount = []
        this.editForm.starttime = ''
        this.editForm.endtime = ''
        this.audittime = ''
        this.auditname = ''
        this.auditrson = ''
        this.imgLoad = new Date().getTime()
      } else {
        this.editTitle = '编辑报备金申请'
        this.infoLoading = true
        getDealerAccountReportById({ darid: id }).then(response => {
          this.editForm.darid = response.data.dar.darid
          this.editForm.delid = response.data.dar.delid
          this.editForm.name = response.data.dar.name
          this.editForm.aid = response.data.dar.aid
          this.editForm.receipttime = response.data.dar.receipttime
          this.editForm.card = response.data.dar.card
          this.editForm.nature = response.data.dar.nature
          this.editForm.amount = response.data.dar.amount
          this.editForm.per = response.data.dar.per
          this.editForm.mindiscount = response.data.dar.mindiscount
          this.editForm.remark = response.data.dar.remark
          this.audittime = response.data.dar.audittime
          this.auditname = response.data.dar.auditname
          this.auditrson = response.data.dar.rson
          let oldimgList = []
          for (let img of response.data.imgs) {
            oldimgList.push({ id: img.img_id, url: img.img_url })
          }
          this.editimgList = oldimgList
          this.imgLoad = new Date().getTime()
          this.editForm.order = []
          for (let o of response.data.daralst) {
            this.editForm.order.push({ address: o.address })
          }
          this.editForm.discount = []
          for (let dis of response.data.dardlst) {
            this.editForm.discount.push({ time: [dis.starttime, dis.endtime], val: dis.discount })
          }
          this.infoLoading = false
        }).catch(() => {
          this.infoLoading = false
        })
      }
      this.editVisible = true
    },
    delApply(id) {
      this.$confirm('删除此报备金申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        deleteDealerAccountReport({ userid: this.user.dUserid, darid: id }).then(response => {
          this.fullscreenLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getData()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const order = qs.parse(this.editForm.order)

            let discountStr = []
            for (let d of this.editForm.discount) {
              discountStr.push({ starttime: d.time[0], endtime: d.time[1], discount: d.val })
            }
            const discount = qs.parse(discountStr)
            const data = {
              userid: this.user.dUserid,
              groupid: this.user.dGroupid,
              darid: this.editForm.darid,
              delid: this.editForm.delid,
              name: this.editForm.name,
              aid: this.editForm.aid,
              receipttime: this.editForm.receipttime,
              card: this.editForm.card,
              nature: this.editForm.nature,
              amount: this.editForm.amount,
              per: this.editForm.per,
              starttime: this.editForm.starttime,
              endtime: this.editForm.endtime,
              mindiscount: this.editForm.mindiscount,
              remark: this.editForm.remark,
              imgStr: this.editForm.imgids.join(','),
              orderStr: order,
              discountStr: discount
            }
            addOrEditDealerAccountReport(data).then(response => {
              this.$message({
                message: '报备金申请提交成功',
                type: 'success'
              })
              this.editVisible = false
              this.editloading = false
              this.editimgList = []
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    view(row) {
      this.imgSrcList = []
      this.viewVisible = true
      this.viewLoading = true
      getDealerAccountReportById({ darid: row.darid }).then(response => {
        this.viewLoading = false
        this.viewdata = response.data.dar
        this.viewAddress = response.data.daralst
        this.viewDiscount = response.data.dardlst
        this.viewAcccount = response.data.acccount
        let imgs = []
        for (let c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgSrcList = imgs
      }).catch(() => {
        this.viewLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bbjzh-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .add-btn{
            position: relative;
            float: right;
            margin-left: 10px;
            margin-top: -10px;
          }
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
